import "datatables.net";
import sislogUserGlobals from "./../../UserGlobals";
import { ColumnDefinition, TableColumn } from "./ColumnDefinitions";

export class DateColumn implements DataTables.ColumnDefsSettings, TableColumn {

    public static formatter: Intl.DateTimeFormat;
    public static formatterWithWeekDay: Intl.DateTimeFormat;
    public static formatterWithTime: Intl.DateTimeFormat;
    public static formatterTime: Intl.DateTimeFormat;

    public static locale: string;
    public className = "c-datatable__date-column-cell";
    public targets: number;
    public property: string;
    public name: string;
    private format: string;
    public orderable = true;
    public definition;

    constructor(column: number, definition: DateColumDefinition) {
        this.targets = column;
        this.property = definition.property;
        this.format = definition.format;
        this.name = this.property;
        this.orderable = definition.orderable;
        this.definition = definition;
    }

    public render = (data: string | number | Date, type: string, row: any) => {
        if (DateColumn.locale !== sislogUserGlobals.language) {
            DateColumn.locale = sislogUserGlobals.language;
            DateColumn.formatter = new Intl.DateTimeFormat(sislogUserGlobals.language, {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                timeZone: "UTC"
            });
            DateColumn.formatterWithTime = new Intl.DateTimeFormat(sislogUserGlobals.language, {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                timeZone: "UTC",
            });
            DateColumn.formatterWithWeekDay = new Intl.DateTimeFormat(sislogUserGlobals.language, {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                weekday: "narrow",
            });
            DateColumn.formatterTime = new Intl.DateTimeFormat(sislogUserGlobals.language, {
                hour: "2-digit",
                minute: "2-digit",
                timeZone: "UTC",
            });
        }
        if (data != null && type === "display") {
            let value = "";
            switch (this.format) {
                case "dateTime":
                    value = DateColumn.formatterWithTime.format(new Date(data));
                    //Fix: Spanish format add ',' separating blocks, date and time: It´s not in our mask, so we will remove it
                    value = value.replace(/, /g, " ");
                    break;
                case "dateWeekday":
                    value = DateColumn.formatterWithWeekDay.format(new Date(data));
                    break;
                case "time":
                    value = DateColumn.formatterTime.format(new Date(data));
                    break;
                default:
                    value = DateColumn.formatter.format(new Date(data));
                    break;
            }
            return value;

        }
        return data;
    }
}

export interface DateColumDefinition extends ColumnDefinition {
    format: "date" | "dateWeekday" | "dateTime" | "time";
    orderable?: boolean;
}
